import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import { createPortal } from "react-dom";
import {
  deleteNotification,
  notificationsSelectors,
  useAppDispatch,
  useAppSelector,
} from "../../store";
import "./Notification.scss";

const body = document.querySelector("body");

interface Props {}
function Notification(props: Props) {
  const notifications = useAppSelector(notificationsSelectors.selectAll);
  const dispatch = useAppDispatch();
  // useEffect(() => {
  //   console.log(notifications);
  // }, [notifications]);

  return createPortal(
    <div className="notification-container">
      <AnimatePresence initial={false}>
        {notifications.map((item) => {
          return (
            <motion.div
              className={`notification-card-${item.type}`}
              key={item.id}
              initial={{ opacity: 0, y: 50, scale: 0.3 }}
              animate={{
                opacity: 1,
                y: 0,
                scale: 1,
              }}
              layout
              exit={{
                opacity: 0,
                scale: 0.5,
              }}
            >
              {(item.type === "error" && (
                <img src="/assets/images/notif-error.svg" alt="error" />
              )) ||
                (item.type === "info" && (
                  <img src="/assets/images/notif-info.svg" alt="info" />
                )) ||
                (item.type === "success" && (
                  <img src="/assets/images/notif-success.svg" alt="success" />
                )) ||
                (item.type === "warning" && (
                  <img src="/assets/images/notif-warning.svg" alt="warning" />
                ))}
              <div className="notification-text">
                <div className="header">{item.type}</div>
                <div className="content">{item.text}</div>
              </div>
              <div
                className="exit-container"
                onClick={() => dispatch(deleteNotification({ id: item.id }))}
              >
                <img src="/assets/images/exit.svg" alt="close" />
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>,
    body as HTMLBodyElement
  );
}
export { Notification as default };
